









































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const indexManagementModule = namespace("index");
@Component({
	components: {},
})
export default class Index extends Vue {
	sysName: string = "";
	showPopup: boolean = false;
	columns: any = [];
	selectVal: any = {};
	selectInex: number = 0;
	parentShow: boolean = false;
	radio: string = "";
	radioList: any = [];

	get actions() {
		return this.columns.map((item: any, index: number) => {
			item.color = "#999";
			if (this.selectInex == index) {
				item.color = "#ff0000";
			}
			return item;
		});
	}

	get selected() {
		return (
			this.actions[this.selectInex] || {
				id: null,
				name: "",
				subname: "",
				color: "#999",
			}
		);
	}

	mounted() {
		this.getUserMsg();
		this.getAccountRelationEntity();
	}
	handleShowPopup() {
		console.log(this.columns);
		if (this.columns.length < 1) {
			return;
		}
		this.showPopup = true;
	}
	onSelect(val: any) {
		this.selectInex = this.actions.findIndex(
			(item: any) => item.id == val.id
		);
	}
	onConfirm(value: any, index: any) {
		console.log(value);
		this.selectVal = value;
		this.showPopup = false;
		this.sysName = value.businessEntityNameCn;
		this.setLocalStorage(
			value.businessEntityId,
			value.businessEntityTypeId
		);
	}
	handleBtn() {
		if (!this.selected || !this.selected.id) {
			return;
		}
		this.$toast({
			type: "loading",
			duration: 0,
			message: "登录系统中.",
			forbidClick: true,
		});
		this.setLocalStorage(this.selected.id, this.selected.typeId);
		this.getParentList(this.selected.id);
	}
	parentBtnCancel() {
		this.parentShow = false;
	}

	parentBtnSure() {
		console.log(this.radioList);
		if (this.radioList) {
			for (let i = 0; i < this.radioList.length; i++) {
				if (this.radio == this.radioList[i].id) {
					this.setParentLocalStorage(
						this.radioList[i].parentBusinessEntityId,
						this.radioList[i].parentBusinessEntityTypeId,
						this.radioList[i].businessEntityNameCn
					);
				}
			}
		}
		console.log(localStorage);
		(this.$router as any).options.routes = [];
		// let pathUrl =
		//   this.selectVal.businessEntityTypeId == 1 ? '/manageHome' : '/home'
		let pathUrl = "/home";
		console.log(pathUrl);
		this.$router.push(pathUrl);
	}
	getUserMsg() {
		let queryParams: Array<string> =
			(window.location as any).href.match(/[^#?&]+=[^#?&]+/gi) || [];
		let params: any = {};
		while (queryParams.length) {
			let query = (queryParams as any).shift().split("=");
			params[query[0]] = query[1];
		}
		let token: string = params.token || localStorage.getItem("ma6_token");
		let accountId: string =
			params.accountId || localStorage.getItem("ma6_accountId");
		let params_info = {
			token,
			accountId,
		};
		localStorage.setItem("ma6_token", params_info.token);

		//设置全局header, 后面的所有请求都会带上这些header信息
		this.$request.setHeader("token", params_info.token);

		//设置全局变量, 在项目任何需要的地方都可以很方便的使用这些变量, 并且这些变量是双向绑定的
		this.$global.set("token", params_info.token);
		this.$global.set("uId", params_info.accountId);
	}
	goBack() {
		const wx: any = (window as any).wx;
		(wx as any).miniProgram.reLaunch({
			url: "/pages/login/login?status=1",
		});
		localStorage.setItem('homeReportSalesTime', '');
	}
	async getAccountRelationEntity() {
		const { success, error }: any = await this.$store.dispatch(
			"index/getAccountRelationEntity",
			{
				accountId: this.$global.uId,
				pageSize: 1000,
			}
		);
		if (success) {
			if (success.data && success.data.list) {
				if (success.data.list.length < 1) {
					this.sysName = "该账号未绑定主体，请联系管理员";
					return;
				}
				this.columns = (success.data.list || []).map((item: any) => {
					const businessEntityType: any = {
						"1": "商场",
						"2": "商铺",
						"3": "品牌商",
						"4": "集团",
						"5": "商户",
						"6": "物业",
						"7": "商管",
						"8": "停车场",
					};
					return {
						id: item.businessEntityId,
						typeId: item.businessEntityTypeId,
						name: item.businessEntityNameCn,
						subname:
							businessEntityType[item.businessEntityTypeId] ||
							"-",
					};
				});
				this.selectInex = 0;
				/* this.sysName = this.columns[0].name;
				this.selectVal = this.columns[0].id; */
			}
		}
		if (error) {
			console.log("error", error);
		}
	}
	/**
	 * 获取商户通系统Id
	 */
	async systemId(businessEntityId: number) {
		const { success, error }: any = await this.$request(
			"GET_ZUKER_SYSTEMID",
			{
				businessEntityId,
			},
			{
				userId: this.$global.uId,
				entityId: businessEntityId,
			}
		);
		if (success && success.data) {
			if (success.data.iMall && success.data.iMallSystemId) {
				localStorage.setItem(
					"ma6_systemId",
					success.data.iMallSystemId
				);
			} else if (success.data.MA6 && success.data.MA6SystemId) {
				localStorage.setItem("ma6_systemId", success.data.MA6SystemId);
			} else {
				this.$toast({
					type: "fail",
					message: "没有MA系统权限!",
					forbidClick: true,
				});
			}
		} else {
			localStorage.setItem("ma6_systemId", "24");
		}
	}
	/**
	 * 获取父级主体列表
	 */
	async getParentList(businessEntityId: any) {
		await this.systemId(businessEntityId);
		const { success, error }: any = await this.$request(
			"PARENTACCOUNT_RELATION_LIST",
			{
				businessEntityId,
			}
		);
		if (success) {
			let radioItems = success.data;
			this.radioList = radioItems;

			if (radioItems) {
				if (radioItems.length > 1) {
					this.parentShow = true;
					this.radio = radioItems[0].id;

					this.$toast({
						type: "fail",
					});
				} else {
					this.parentShow = false;
					this.radio = radioItems[0].id;
					radioItems =
						radioItems && radioItems.length == 1
							? radioItems[0]
							: null;
					this.setParentLocalStorage(
						radioItems.parentBusinessEntityId,
						radioItems.parentBusinessEntityTypeId,
						radioItems.businessEntityNameCn
					);
					(this.$router as any).options.routes = [];
					// let pathUrl =
					//   this.selectVal.businessEntityTypeId == 1 ? "/manageHome" : "/home";
					let pathUrl = "/home";
					console.log(pathUrl);
					this.$router.push(pathUrl);

					this.$toast({
						type: "success",
						forbidClick: true,
						duration: 3000,
					});
				}
			} else {
				(this.$router as any).options.routes = [];
				// let pathUrl =
				//   this.selectVal.businessEntityTypeId == 1 ? '/manageHome' : '/home'
				let pathUrl = "/home";
				console.log(pathUrl);
				this.$router.push(pathUrl);

				this.$toast({
					type: "success",
					forbidClick: true,
					duration: 3000,
				});
			}
		}
	}
	setLocalStorage(tenantId: any, tenantType: any) {
		localStorage.setItem("ma6_businessEntityId", tenantId);
		localStorage.setItem("ma6_businessEntityTypeId", tenantType);
		//设置全局header, 后面的所有请求都会带上这些header信息
		this.$request.setHeader("tenantId", tenantId);
		this.$request.setHeader("tenantType", tenantType);

		//设置全局变量, 在项目任何需要的地方都可以很方便的使用这些变量, 并且这些变量是双向绑定的.
		this.$global.set("tenantId", tenantId);
		this.$global.set("tenantType", tenantType);
	}
	setParentLocalStorage(parentId: any, parentType: any, parentName: any) {
		localStorage.setItem("ma6_parentBusinessEntityId", parentId);
		localStorage.setItem("ma6_parentBusinessEntityTypeId", parentType);
		localStorage.setItem("ma6_parentName", encodeURIComponent(parentName));
		this.$global.set("parentName", encodeURIComponent(parentName));
	}
}
